module.exports = "/images/ThankyouGradientMobile_v2.png?6efc76756d72a0d60756b60638634ef8";